export default __webpack_public_path__ + "static/media/Home_BG-04.bb450534.png";